import userTranslationsHelper from "../../../../../../languages/user-translations.helper";
import {
  DriverPlanEntryCheckoutEventAddDefaultErrorType,
  DriverPlanEntryCheckoutEventAddErrorType,
  DriverPlanEntryCheckoutEventDefaultError,
  DriverPlanEntryCheckoutEventDriverHasCandidatureError,
} from "./driver-plan-entry-checkout-event-add-error";

const createDriverHasCandidatureError =
  (): DriverPlanEntryCheckoutEventDriverHasCandidatureError => {
    const translations =
      userTranslationsHelper.getDriverDetailsActiveRoutePlansTranslations()
        .addCheckout;

    return {
      message: translations.apiErrors.driverHasCandidatureErrorLabel,
      params: {},
      type: DriverPlanEntryCheckoutEventAddErrorType.DRIVER_HAS_CANDIDATURE,
    };
  };

const createDefaultError = (): DriverPlanEntryCheckoutEventDefaultError => {
  const translations =
    userTranslationsHelper.getDriverDetailsActiveRoutePlansTranslations()
      .addCheckout;

  return {
    message: translations.failureNotificationText,
    params: {},
    type: DriverPlanEntryCheckoutEventAddDefaultErrorType.DEFAULT,
  };
};

const driverPlanEntryCheckoutEventAddErrorFactory = {
  createDriverHasCandidatureError,
  createDefaultError,
};

export default driverPlanEntryCheckoutEventAddErrorFactory;
